import React, {useState} from 'react';
import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Paper, Typography} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {DeleteOutline} from "@mui/icons-material";
import {RoleCheck} from "../../library/RoleCheck";
import {RowRequests} from "../../api/requests/RowRequests"
import RowJson from "../../api/json/RowJson"
import {useToasts} from "../../hooks/useToasts"

interface RowActionsMenuProps {
    row?: RowJson
    didDelete: () => void
    size?: "small" | "medium"
}

function RowActionsMenu({row, didDelete, size}: RowActionsMenuProps) {
    const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement>()

    const [deleteInProgress, setDeleteInProgress] = useState(false)

    const toasts = useToasts()

    const handleDelete = () => {
        if (!row) return

        setDeleteInProgress(true)
        RowRequests.delete(row.id)
            .then(() => didDelete && didDelete())
            .catch(toasts.showError)
            .finally(() => setDeleteInProgress(false))
    }

    if (!RoleCheck.isAdmin() || !row) {
        return <></>
    }

    return (
        <>
            <IconButton size={size} onClick={(event) => setMenuAnchor(event.currentTarget)}>
                <MoreVertIcon fontSize={size}/>
            </IconButton>

            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={() => setMenuAnchor(undefined)}
            >
                <Paper variant="outlined">
                    <MenuList>
                        {RoleCheck.isAdmin() && row &&
                            <MenuItem disabled={deleteInProgress}
                                      onClick={() => {
                                          setMenuAnchor(undefined)
                                          handleDelete()
                                      }}
                            >
                                <ListItemIcon>
                                    <DeleteOutline color="error"/>
                                </ListItemIcon>
                                <ListItemText>
                                    <Typography color="error">Delete</Typography>
                                </ListItemText>
                            </MenuItem>
                        }
                    </MenuList>
                </Paper>
            </Menu>
        </>
    )
}

export default RowActionsMenu;